var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWishListMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.6 0h14.9c.3 0 .5.2.5.6v14.9c0 .3-.2.5-.5.5H.6c-.3 0-.6-.2-.6-.5V.6C0 .2.2 0 .6 0z",
    fill: "#1e7fc0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.1c1.7 1.6 3.1 3.4 4.2 5.5 3.1-3.5 7.2-6.1 11.8-7.3V3.7S9.8 4.9 4.3 11.2C3.1 9.4 1.6 7.8 0 6.4v1.7z",
    fill: "#fff"
  })));
}

export default SvgIconWishListMember;